<template>
	<ul class="message-list" :style='{width : width}'>
		<slot></slot>
	</ul>
</template>
<script>
	export default {
		name:'message-list',
		props:['size','line-height','width','marginBottom','color'],
		provide() {
	      return {
	        meList: this
	      };
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/message-list.vue